import styled from '@emotion/styled'
import { ellipsis } from 'polished'

export const OverflowEllipsis = styled('div')({
  ...ellipsis(),
})
